import { Flex, Loader, Text, Stack, Title, Box } from '@mantine/core';
import { useTranslation } from 'react-i18next';

const AuthLoadingScreen = () => {
  const { t } = useTranslation();
  return (
    <Flex
      style={{
        minHeight: '100vh',
        background: 'var(--mantine-color-gray-0)',
      }}
      justify='center'
      align='center'
    >
      <Stack align='center' gap='xl'>
        {/* Logo BECOME */}
        <Box>
          <Title
            order={1}
            style={{
              fontSize: '3rem',
              fontWeight: 700,
              letterSpacing: '-0.02em',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            BECOME.
          </Title>
        </Box>

        {/* Loading indicator */}
        <Stack align='center' gap='md'>
          <Loader size='xl' color='blue' />
          <Text size='sm' c='dimmed' ta='center'>
            {t('loading', 'Caricamento in corso...')}
          </Text>
        </Stack>
      </Stack>
    </Flex>
  );
};

export default AuthLoadingScreen;
